import { Outlet } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import FloatingActions from "@/components/FloatingActions";
import { Toaster } from "@/components/ui/sonner";

const Layout = () => (
  <div className="App font-body bg-white">
    <Header />
    <main className="flex-1">
      <Outlet />
    </main>
    <Footer />
    <FloatingActions />
    <Toaster position="top-right" />
  </div>
);

export default Layout;
